import { Alert, Snackbar as MuiSnackbar } from '@mui/material';
import React from 'react';

export interface SnackbarProps {
    open: boolean;
    message: string;
    severity?: 'success' | 'error' | 'warning' | 'info';
    autoHideDuration?: number;
    onClose: () => void;
    anchorOrigin?: {
        vertical: 'top' | 'bottom';
        horizontal: 'left' | 'center' | 'right';
    };
}

export default function Snackbar({
    open,
    message,
    severity = 'success',
    autoHideDuration = 3000,
    onClose,
    anchorOrigin = { vertical: 'bottom', horizontal: 'center' }
}: SnackbarProps) {
    return (
        <MuiSnackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
        >
            <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </MuiSnackbar>
    );
}
